import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import {
  CustomTemplateData,
  PayOnAccountPaymentPreviewV1Response,
} from '@arc/unified-payments-frontend/shared-payment';

export const PoaPadResultComponentPaymentPreviewActions = createActionGroup({
  source: 'Pad Result Component Payment Preview',
  events: {
    'Load Payment Preview Success': props<{
      payload: PayOnAccountPaymentPreviewV1Response;
    }>(),
    'Load Payment Preview Error': props<{ error: HttpErrorResponse }>(),
    'Restore Custom Template Data From Preview': props<{
      payload: CustomTemplateData;
    }>(),
  },
});
